import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configPlatform/delete/uptime.configPlatform.delete.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigPlatformDeleteMutation,
  UptimeConfigPlatformDeleteMutationVariables,
} from "@/v2-backoffice-client/uptime/configPlatform/delete/__types__/uptime.configPlatform.delete.mutation"

type Options = MutationHookOptions<
  UptimeConfigPlatformDeleteMutation,
  UptimeConfigPlatformDeleteMutationVariables
>

export function useUptimeConfigPlatformDeleteMutation(options?: Options) {
  return useMutation<
    UptimeConfigPlatformDeleteMutation,
    UptimeConfigPlatformDeleteMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
